import { doc, setDoc } from 'firebase/firestore';
import { IComparisonPopulationSetting } from '../../providers/settings/comparisonPopulationSettingsProvider';
import { userAsPromise } from '../../providers/userProvider';

/**
 * @description saves the comparison population setting for the user
 * @param settings
 */
export const saveComparisonPopulationSetting = async (
  settings: IComparisonPopulationSetting
): Promise<void> => {
  const user = await userAsPromise();

  return setDoc(
    doc(
      user.services.firestore,
      `/userProfiles/${user.id}/settings/comparisonPopulation`
    ),
    settings,
    { merge: true }
  );
};
